// "Was ist neu?" – pro Release eine ID. Neue Release-ID ⇒ Tour erscheint erneut (einmal pro Nutzer).
// page: "global" (Dashboard) | "draw" (Skizze / Foto-Annotation). roles: null = alle.
export const RELEASE_ID = "2026-06-messen";

const FIELD = ["admin", "super_admin", "sales_director", "sales_manager", "sales_rep", "branch_manager", "installer", "frei", "user"];

export const STEPS = [
  {
    page: "global", roles: null,
    title: "Was ist neu?",
    body: "Ein paar Neuerungen seit dem letzten Update – in 1 Minute erklärt. Du kannst die Tour jederzeit überspringen.",
  },
  {
    page: "global", roles: FIELD,
    title: "Messen in Skizze & Foto",
    body: "Mit dem Lineal ein bekanntes Maß als Referenz einzeichnen – danach misst die App jede weitere Linie automatisch in mm. Mit dem Flächen-Werkzeug Ecken antippen ⇒ m².",
    where: "Projekt → Fotos / Skizze → Lineal-Symbol",
  },
  {
    page: "global", roles: FIELD,
    title: "Maße benennen",
    body: "Jedes Maß und jede Fläche bekommt jetzt eine Bezeichnung – frei getippt oder per Schnellvorschlag (z. B. „Heizraum“, „Abstand Außengerät“). Die Namen erscheinen in der Maßliste im V-Check-PDF unter dem Grundriss.",
    where: "Nach dem Messen im Dialog „Maß eintragen“",
  },
  {
    page: "global", roles: FIELD,
    title: "Zoom & Vollbild",
    body: "Skizzen und Fotos lassen sich jetzt zoomen, verschieben und im Vollbild bearbeiten – ideal auf dem iPad für feine Details.",
    where: "Oben rechts im Zeichenbereich",
  },
  {
    page: "global", roles: ["admin"],
    selector: "[data-testid='dashboard-user-activity-tile']",
    title: "Nutzer-Aktivität",
    body: "Sieh, wer wann aktiv gearbeitet hat – mit Zeitfilter und CSV-Export.",
  },
  {
    page: "global", roles: null,
    title: "Neue Version? Banner!",
    body: "Gibt es ein Update, erscheint unten ein Hinweis „Neue Version verfügbar“. Einmal auf „Jetzt aktualisieren“ tippen – fertig.",
  },
  {
    page: "global", roles: null,
    selector: "[data-testid='app-help-btn']",
    title: "Hilfe & Neuigkeiten",
    body: "Über das Fragezeichen findest du die Hilfe zur aktuellen Seite – und dort kannst du diese Tour jederzeit wieder starten.",
  },
  {
    page: "draw", roles: null,
    selector: "[data-testid='sketch-ruler-btn'],[data-testid='annotator-ruler-btn']",
    title: "Lineal",
    body: "Linie ziehen und das echte Maß eintragen = Referenz. Jede weitere Linie wird automatisch gemessen. Neu: gib dem Maß direkt einen Namen.",
  },
  {
    page: "draw", roles: null,
    selector: "[data-testid='sketch-ruler-btn-area'],[data-testid='annotator-ruler-btn-area']",
    title: "Fläche messen",
    body: "Eckpunkte antippen, zum Schließen auf den ersten Punkt tippen – die m² werden berechnet und können benannt werden.",
  },
  {
    page: "draw", roles: null,
    selector: "[data-testid='sketch-zoom-controls'],[data-testid='annotator-zoom-controls']",
    title: "Zoom & Vollbild",
    body: "Vergrößern, verschieben und Vollbild – für präzises Messen und Zeichnen.",
  },
  {
    page: "draw", roles: null,
    selector: "[data-testid='sketch-save-btn'],[data-testid='annotator-save-btn']",
    title: "Speichern = ins PDF",
    body: "Beim Speichern landen alle Maße mit Bezeichnung in der Maßliste des V-Check-PDFs.",
  },
];

export const stepsFor = (page, role) =>
  STEPS.filter((s) => s.page === page && (!s.roles || s.roles.includes(role)));
